import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsTypeRoute: InvariantJiraRoute = {
	name: 'servicedesk-reports-type',
	path: '/jira/servicedesk/projects/:projectKey/reports/:reportType/:reportId?/:reportsAction?/:timescaleId?/:issueKey?',
	query: ['oldIssueView?'],
};
